import React from "react";
import { Button, Drawer, HStack, IconButton, Placeholder, VStack } from "rsuite";
import { FaWhatsapp } from "react-icons/fa";
import { IoCallOutline } from "react-icons/io5";
import { IoIosArrowForward } from "react-icons/io";
import { IoLogoWhatsapp } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { FaCheck } from "react-icons/fa6";
import { GoDotFill } from "react-icons/go";

import styles from "./ReferStatus.module.scss";

export default function ReferStatusDrawer({ open, setOpen }) {
  return (
    <div>
      <Drawer placement="bottom" open={open} onClose={() => setOpen(false)} size="lg">
        <Drawer.Body>
          <div className={styles.line} />

          <VStack alignItems="stretch" spacing={5}>
            <HStack justifyContent="space-between" alignItems="center">
              <h6>9030137623</h6>
              <div>
                <IconButton icon={<IoLogoWhatsapp size={30} color="#0ebb53" />} appearance="link" />
                <IconButton icon={<IoCall size={27} color="#585858" />} appearance="link" />
              </div>
            </HStack>

            <div>
              <p>Here is your friend's journey!</p>
              <p>Remind, before you loose your reward</p>
            </div>

            <div className={styles.time__line}>
              <ul>
                <li>
                  <span className={`${styles.icon} ${styles.green}`}>
                    <FaCheck color="#ffffff" size={12} />
                  </span>
                  <span className={styles.text}>Joined</span>
                </li>
                <li>
                  <span className={`${styles.icon} ${styles.green}`}>
                    <FaCheck color="#ffffff" size={12} />
                  </span>
                  <span className={styles.text}>KYC Verification</span>
                </li>
                <li>
                  <span className={`${styles.icon} ${styles.blue}`}>
                    <GoDotFill color="#ffffff" size={22} />
                  </span>
                  <span className={styles.text}>Apply Loan</span>
                </li>
                <li>
                  <span className={`${styles.icon} ${styles.gray}`}>
                    <GoDotFill color="#ffffff" size={22} />
                  </span>
                  <span className={styles.text} style={{ color: "#9f9f9f" }}>
                    Approved
                  </span>
                </li>
                <li>
                  <span className={`${styles.icon} ${styles.gray}`}>
                    <GoDotFill color="#ffffff" size={22} />
                  </span>
                  <span className={styles.text} style={{ color: "#9f9f9f" }}>
                    Disbursal
                  </span>
                </li>
              </ul>
            </div>

            <Button color="red" appearance="primary" size="lg" style={{ background: "#182bda" }}>
              Done
            </Button>
          </VStack>
        </Drawer.Body>
      </Drawer>
    </div>
  );
}
